import React from "react";

import { Button, FlexBox, Heading } from "@braze/beacon-core";
import { useSpacing } from "@braze/beacon-styling";

import useI18nNamespace from "@services/useI18nNamespace";

import { StyledHeading } from "./FormHeaderText.style";

export const FormHeaderText = () => {
  const { t } = useI18nNamespace("free-trial-registration");
  const getSpacing = useSpacing();
  const handleLogInClick = () => {
    const signInLink = "https://dashboard-09.braze.com/sign_in";
    window.open(signInLink, "_blank");
  };

  return (
    <FlexBox direction="column" justifyContent="center" alignItems="center" mt="sm">
      <StyledHeading level={2} data-cy="registrationFormHeading">
        {t("welcome-text", "Let’s get you the best Braze experience!")}
      </StyledHeading>
      <FlexBox direction="row" justifyContent="center" gap={getSpacing("xs")} mt="xl" mb="lg">
        <Heading level={5} data-cy="accountLoginHeading">
          {t("already-have-account-text", "Already have an account?")}
        </Heading>
        <Button data-cy="accountLoginButton" variant="quaternary" onClick={handleLogInClick}>
          {t("login-button-text", "Log in")}
        </Button>
      </FlexBox>
    </FlexBox>
  );
};

export default FormHeaderText;
